import http from "@/plugins/axios";

const receiptApiCall = async (
    params,
    abortController = null,
) => {
    const { data } = await http.get('/api/company/v3/document/history', { signal: abortController?.signal, params })
    return data
}

const receiptUploadApiCall = async (
    params,
    abortController = null,
) => {
    const { data } = await http.post(`/api/company/v3/document/${params.type}/upload`,
        params.data,
        {
            signal: abortController?.signal,
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        })
    return data
}

const receiptDeleteApiCall = async (
    params,
    abortController = null,
) => {
    const { data } = await http.delete(`/api/company/v3/document/${params.id}`,
        {
            signal: abortController?.signal,
        })
    return data
}

export {
    receiptApiCall,
    receiptUploadApiCall,
    receiptDeleteApiCall,
}